
import { defineComponent } from 'vue'
export default defineComponent({
  name: 'DependencyInfoBlock',
  props: {
    title: {
      type: String,
      required: true
    },
    text: {
      type: String,
      default: ''
    },
    loading: {
      type: Boolean,
      default: false
    }
  }
})
